module.exports = __webpack_public_path__ + "static/img/Philippines2-Solar-lamp-library.679bc49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Philippines2-Solar-lamp-library.jpg
// module id = kfs8
// module chunks = 0